export default "__VITE_ASSET__a123dfc7__"